import React from 'react'
import { mount } from 'enzyme'

import Loader from '../Loader'

describe('Component: Loader', () => {
  let wrapper, props

  beforeAll(() => {
    props = {
      number: 1
    }
    wrapper = mount(<Loader {...props} />)
  })

  describe("#render",() => {
    it('should return content', () => {

      expect(wrapper).toBeTruthy()
    })
  })

})
